import React, { useEffect } from "react";
import "./App.css";
import RouterConfig from "./utils/routing";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { I18nextProvider } from "react-i18next";
import i18n from "./language/i18n";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

function App() {
  useEffect(() => {
    // Restore saved language
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }

    // Service worker registration with update handling
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        toast.info(
          <div>
            <p style={{ margin: 0 }}>🚀 A new update is available!</p>
            <button
              style={btnStyle("#007bff")}
              onClick={() => {
                if (registration?.waiting) {
                  registration.waiting.postMessage({ type: "SKIP_WAITING" });
                  registration.waiting.addEventListener("statechange", (e) => {
                    if (e.target.state === "activated") {
                      window.location.reload();
                    }
                  });
                }
              }}
            >
              Update Now
            </button>
          </div>,
          { autoClose: false }
        );
      },
    });
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ToastContainer />
      <RouterConfig />
    </I18nextProvider>
  );
}

// Reusable button style for update button
const btnStyle = (bg) => ({
  marginTop: "8px",
  padding: "6px 14px",
  border: "none",
  borderRadius: "4px",
  background: bg,
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
});

export default App;
